import React, { ChangeEventHandler, MouseEventHandler, ReactElement } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import { POST_SEARCH_OPTIONS } from '../../../../../utils/constants';

import { HashTag, Member, Post } from '../../../../../types/entity.types';
import { RadioOrSelectOption } from '../../../../../types/common.types';

import TribeInfo from '../info/TribeInfo';
import TribeFeedWrapper from './wrapper/TribeFeedWrapper';
import TribePostContainer from '../../../../../containers/programme/tribe/tribe-post/TribePost.container';

import './tribe-feed.scss';

type Props = {
  profilePicture?: string;
  status: string;
  onComposeClick: MouseEventHandler<HTMLButtonElement>;
  posts: Post[];
  members: Member[];
  searchType?: RadioOrSelectOption;
  onSearchTypeChange: (option: RadioOrSelectOption) => void;
  filterValue: string;
  onFilterValueChange: ChangeEventHandler<HTMLInputElement>;
  refreshPost: (postExternalReference: string) => void;
  hashtags?: HashTag[];
  setComposing: (value: boolean) => void;
  loadPosts: () => void;
  onSearchClick: MouseEventHandler<HTMLButtonElement>;
  pendingApprovals: number;
};

const TribePostsFeed = ({
  profilePicture,
  status,
  onComposeClick,
  posts,
  members,
  searchType = POST_SEARCH_OPTIONS[0],
  onSearchTypeChange,
  filterValue,
  onFilterValueChange,
  refreshPost,
  hashtags = [],
  setComposing,
  loadPosts,
  pendingApprovals,
  onSearchClick
}: Props): ReactElement => (
  <div className="tribe-feed" data-testid="tribe-feed">
    <div className="tribe-feed__header">
      <h1>Tribe Feed</h1>
    </div>
    <div className="tribe-feed__content">
      <TribeFeedWrapper
        profilePicture={profilePicture}
        status={status}
        onComposeClick={onComposeClick}
        onSearchClick={onSearchClick}
        searchType={searchType}
        onSearchTypeChange={onSearchTypeChange}
        filterValue={filterValue}
        onFilterValueChange={onFilterValueChange}
      >
        <div className="tribe-feed__posts" id="tribe-feed-posts" data-testid="tribe-feed-posts">
          {posts.length > 0 && (
            <InfiniteScroll
              dataLength={posts.length}
              next={loadPosts}
              hasMore
              scrollableTarget="tribe-feed-posts"
              loader={<React.Fragment />}
            >
              {posts.map(
                (post: Post): ReactElement => (
                  <div key={post.externalReference}>
                    <TribePostContainer
                      key={post.externalReference}
                      status={status}
                      post={post}
                      hashtags={hashtags}
                      refreshPost={refreshPost}
                      setComposing={setComposing}
                      searchType={searchType}
                    />
                  </div>
                )
              )}
            </InfiniteScroll>
          )}
          {posts.length === 0 && (
            <div className="tribe-feed__posts--empty">
              <p>No Posts</p>
            </div>
          )}
        </div>
      </TribeFeedWrapper>
      <TribeInfo status={status} pendingApprovals={pendingApprovals} members={members} />
    </div>
  </div>
);

export default TribePostsFeed;
